<template>
  <collapsible-section
    class="collapse-item"
    :id="`objectModelUsersCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`"
    control-name="objectModelUsersCollapse"
    :is-open="false"
  >
    <template #section-header>
      <row>
        <column>
          Users
        </column>
      </row>
    </template>
    <template #section-contents>
      <template v-for="section in handler.userDataSections(lowerQ)">
        <field-item
          v-for="field in section.fields"
          :key="field.id"
          :disabled="handler.isDisabled(field, parentTreeContext)"
          @click="select(section.select(field, section.type))"
        >
          <row>
            <prefix>
              <icon glyph="member" />
            </prefix>
            <column>
              {{field.label}}
            </column>
          </row>
        </field-item>
      </template>
    </template>
  </collapsible-section>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from '../mixins/handlerComponentsMixin';
import FieldItem from './common/field-item.vue';
import DynamicFieldsHandler from "~/models/dynamicFields/handlers/dynamicFieldsHandler";
import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin'
import CollapsibleSection from "~/components/dynamicFieldsTrees/handlerComponents/common/collapsible-section.vue";
import ObjectModel from "~/models/objectModel";
import ObjectModelAccountRelationData from "./object-model-account-relation-data.vue";
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import {IDynamicTreeContext} from "~/interfaces/dynamicFieldsInterfaces";
import {ReferenceNodeType} from "~/enums/referenceNodeType";

export default Vue.extend({
  mixins: [
    handlerComponentsMixin,
    handlerTreeContextMixin,
  ],
  components: {
    FieldItem,
    CollapsibleSection,
    ObjectModelAccountRelationData,
  },
  data: function() {
    return {
      ReferenceNodeType,
    }
  },
  props: {
    handler: {
      type: DynamicFieldsHandler,
      required: true,
    },
    objectModel: {
      type: Object as () => ObjectModel,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    path: {
      type: Array as () => ReferencePathNode[],
      required: true,
    }
  },
  computed: {
    treeContext(): IDynamicTreeContext {
      return {
        parent: this.objectModel,
        isTopLevelCollectionAssigned: this.parentTreeContext.isTopLevelCollectionAssigned || this.handler.isTopLevelCollection(this.objectModel, this.parentTreeContext),
        referencePathNodesToLevel: this.path,
      }
    },
  },
  methods: {
  },
});
</script>